module.exports = __webpack_public_path__ + "img/hide-chart-bar.098ff240.svg";